import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { ResponseType } from '../../../enums';
import { responsesActions } from '../../../redux/slices/responsesSlice';
import { ResponsesRoutes } from '../../../routes';
import { ReactComponent as NoResultsIcon } from '../../../assets/no-results-search-icon.svg';

import './styles.scss';

interface Props {
    type: ResponseType;
    loading: boolean;
    showEmptyFilterResult: boolean;
}

export const NoResults = ({ type, loading, showEmptyFilterResult }: Props) => {
    const dispatch = useAppDispatch();

    const clearFiltersHandler = () => dispatch(responsesActions.clearFilters());

    const content = useMemo(() => {
        if (showEmptyFilterResult && type === ResponseType.Archive) {
            return (
                <>
                    <h6 className='responses-table-empty-result__title'>
                        {__t('За вашим запитом не знайдено жодного відгуку')}
                    </h6>
                    <button className='responses-table-empty-result__filter-reset-button' onClick={clearFiltersHandler}>
                        {__t('Скинути налаштування фільтру')}
                    </button>
                </>
            );
        }

        if (showEmptyFilterResult && type !== ResponseType.Archive) {
            return (
                <>
                    <h6 className='responses-table-empty-result__title'>
                        {__t('За вашим запитом не знайдено жодного відгуку')}
                    </h6>
                    <p className='responses-table-empty-result__text'>{__t('Спробуйте пошукати в Архіві.')}</p>
                    <Link to={ResponsesRoutes.Archived} className='responses-table-empty-result__archive-link'>
                        <Icon
                            icon='box-archive-regular'
                            color='highlight'
                            className='responses-table-empty-result__filter-reset-button-icon'
                        />
                        {__t('Шукати в Архіві')}
                    </Link>
                </>
            );
        }

        switch (type) {
            case ResponseType.Applied:
                return (
                    <>
                        <h6 className='responses-table-empty-result__title'>
                            {__t('У вас нема жодного Отриманого відгуку ')}
                        </h6>
                        <p className='responses-table-empty-result__text'>
                            {__t('Створюйте вакансії і отримані відгуки від працівників зʼявляться тут.')}
                        </p>
                    </>
                );
            case ResponseType.Invited:
                return (
                    <>
                        <h6 className='responses-table-empty-result__title'>
                            {__t('У вас нема жодного Надісланого відгуку')}
                        </h6>
                        <p className='responses-table-empty-result__text'>
                            {__t('Запрошуйте працівників на ваші вакансії і надіслані відгуки зʼявляться тут.')}
                        </p>
                    </>
                );
            case ResponseType.Mutual:
                return (
                    <>
                        <h6 className='responses-table-empty-result__title'>
                            {__t('У вас нема жодного Взаємного відгуку')}
                        </h6>
                        <p className='responses-table-empty-result__text'>
                            {__t('Отримані і надіслані відгуки зʼявляться тут.')}
                        </p>
                    </>
                );
            case ResponseType.Archive:
                return (
                    <>
                        <h6 className='responses-table-empty-result__title'>
                            {__t('У вас нема жодного відгуку в Архіві')}
                        </h6>
                        <p className='responses-table-empty-result__text'>
                            {__t('Заархівовані відгуки зʼявляться тут.')}
                        </p>
                    </>
                );
            default:
                return '';
        }
    }, [type, showEmptyFilterResult]);

    if (loading) {
        return null;
    }

    return (
        <div className='responses-table-empty-result'>
            <NoResultsIcon className='responses-table-empty-result__icon' />
            {content}
        </div>
    );
};
